import { render, staticRenderFns } from "./QResourcesSubmenu.vue?vue&type=template&id=07fee815&"
import script from "./QResourcesSubmenu.vue?vue&type=script&lang=js&"
export * from "./QResourcesSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports